import React, { type ReactNode } from 'react';
import { Pressable } from 'react-aria-components';

export function PressableButton({ children }: { children: ReactNode }) {
	return (
		<Pressable>
			<button type="button">{children}</button>
		</Pressable>
	);
}
